import React from 'react';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import TierStatisticsBar from '../../../../DeviationViews/Helper/StatisticsBar/TierStatisticsBar';
import s from './TierCardForExplorer.scss';
const COVER_IMAGE_RATIO = 1.774;
const coverImagePadding = parseInt(s['padding']);
const TierCardForExplorer = ({ deviation, width, onClick })=>{
    const { title, coverImage, tier } = deviation;
    const { stats } = tier || {};
    if (!deviation.tier) {
        return null;
    }
    const onClickHandler = ()=>onClick(deviation);
    const coverImageWidth = width - 2 * coverImagePadding;
    const coverImageHeight = width / COVER_IMAGE_RATIO;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        onClick: onClickHandler
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['dumbo-wrapper']
    }, coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['dumbo'],
        deviation: coverImage,
        width: coverImageWidth,
        height: coverImageHeight
    }) : /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder-cover'],
        style: {
            width: coverImageWidth,
            height: coverImageHeight
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), /*#__PURE__*/ React.createElement(TierStatisticsBar, {
        className: s['stats'],
        stats: stats
    }));
};
TierCardForExplorer.displayName = 'TierCardForExplorer';
export default TierCardForExplorer;

//# sourceMappingURL=TierCardForExplorer.js.map